import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ukWhen } from "@/lib/time";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CellMain, CellSub, Empty, St, Tb, Td, Th } from "@/components/portal/crm/kit";

/** The people an introducer has put on their own portal — read-only from the Hub. */
export function SeatsDialog({ party, onOpenChange }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!party?.id) { setItems(null); return undefined; }
    let alive = true;
    api.get(`/hub/referrers/${party.id}/seats`)
      .then((r) => { if (alive) setItems(r.data.items || []); })
      .catch(() => { if (alive) setItems([]); });
    return () => { alive = false; };
  }, [party?.id]);

  return (
    <Dialog open={!!party} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="hub-seats-dialog">
        <DialogHeader>
          <DialogTitle className="text-[19px] tracking-[-0.01em]">Seats at {party?.company || party?.name}</DialogTitle>
          <DialogDescription className="text-[13px]">
            Agents the account holder has given their own sign-in. Each sees only the cases they put in; Connexis pays
            the company, and any share in the last column is an internal split the holder settles with them.
          </DialogDescription>
        </DialogHeader>
        {items === null ? (
          <Empty testId="hub-seats-loading">Reading their team…</Empty>
        ) : items.length === 0 ? (
          <Empty testId="hub-seats-empty">No seats — every case comes from the account holder.</Empty>
        ) : (
          <div className="cxp">
            <Tb testId="hub-seats-table" head={<>
              <Th style={{ width: "34%" }}>Person</Th>
              <Th style={{ width: "14%" }}>Access</Th>
              <Th className="r" style={{ width: "11%" }}>Cases</Th>
              <Th className="r" style={{ width: "11%" }}>Live</Th>
              <Th className="r" style={{ width: "14%" }}>Their share</Th>
              <Th className="r" style={{ width: "16%" }}>Last active</Th>
            </>}>
              {items.map((s) => (
                <tr key={s.id} data-testid={`hub-seat-row-${s.id}`}>
                  <Td className="lead">
                    <CellMain>{s.name}</CellMain>
                    <CellSub>{s.email}{s.phone ? ` · ${s.phone}` : ""}</CellSub>
                  </Td>
                  <Td>
                    <St tone={s.status === "paused" ? "slate" : s.activated ? "mint" : "ink"}>
                      {s.status === "paused" ? "Paused" : s.activated ? "Active" : "Invited"}
                    </St>
                  </Td>
                  <Td className="r"><CellMain>{s.cases}</CellMain></Td>
                  <Td className="r"><CellMain>{s.live_cases}</CellMain></Td>
                  <Td className="r" data-testid={`hub-seat-split-${s.id}`}>
                    {s.split_pct ? <CellMain>{s.split_pct}%</CellMain> : <CellSub>None set</CellSub>}
                  </Td>
                  <Td className="r"><CellSub>{s.last_seen ? ukWhen(s.last_seen) : s.activated ? "Not yet" : "No password yet"}</CellSub></Td>
                </tr>
              ))}
            </Tb>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
